import shortDate from './date/shortDate'

export default {
  install(app) {
    app.config.globalProperties.$filters = {
      shortDate
    }
  }
}
